<template>
  <div class="admin-main">
    
    <div class="header">
      <h2>어드민 홈</h2>
    </div>

    <div class="content">
      
      <div class="header">
        <h2>안녕하세요! <b>{{ member_info.name }}</b> 관리자님!</h2>
      </div>

      <div class="item">
        <ul class="row-list">
          <li>
            <div class="top">
              <div class="left">
                <h2>버그 리포트</h2>
                <span>전체 접수</span>
              </div>
              <div class="right">
                <h2>{{ bugStats.total }}</h2>
              </div>
            </div>
            <div class="bottom">
              <span>총 {{ bugStats.total }}건 접수됨</span>
            </div>
          </li>
          <li>
            <div class="top">
              <div class="left">
                <h2>대기 중</h2>
                <span>미처리 버그</span>
              </div>
              <div class="right">
                <h2 class="pending-count">{{ bugStats.pending }}</h2>
              </div>
            </div>
            <div class="bottom">
              <span>확인이 필요합니다</span>
            </div>
          </li>
          <li>
            <div class="top">
              <div class="left">
                <h2>처리 완료</h2>
                <span>해결된 버그</span>
              </div>
              <div class="right">
                <h2>{{ bugStats.resolved }}</h2>
              </div>
            </div>
            <div class="bottom">
              <span>{{ bugStats.total > 0 ? Math.round(bugStats.resolved / bugStats.total * 100) : 0 }}% 해결률</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- 최근 버그 리포트 -->
      <div class="whole">
        <div class="section-header">
          <h3>최근 버그 리포트</h3>
        </div>
        <div class="recent-list" v-if="recentBugs.length > 0">
          <div class="recent-item" v-for="bug in recentBugs" :key="bug.idx">
            <div class="recent-left">
              <span class="status-dot" :class="bug.status"></span>
              <div class="recent-info">
                <h4>{{ bug.location }}</h4>
                <p>{{ bug.description }}</p>
              </div>
            </div>
            <div class="recent-right">
              <span class="reporter">{{ bug.mb_id }}</span>
              <span class="date">{{ formatDate(bug.created_at) }}</span>
            </div>
          </div>
        </div>
        <div class="no-data" v-else>
          <p>접수된 버그 리포트가 없습니다.</p>
        </div>
      </div>
      
    </div>

  </div>
</template>


<script>
import { inject, ref, onMounted } from "vue";

export default {
  name: "adminHome",
  setup() {

    const member_info = inject("member_info");
    const sql_query = inject("sql_query");

    const bugStats = ref({ total: 0, pending: 0, reviewing: 0, resolved: 0, closed: 0 })
    const recentBugs = ref([])

    function formatDate(dateStr) {
      if (!dateStr) return ""
      const d = new Date(dateStr)
      const m = String(d.getMonth() + 1).padStart(2, "0")
      const day = String(d.getDate()).padStart(2, "0")
      const h = String(d.getHours()).padStart(2, "0")
      const min = String(d.getMinutes()).padStart(2, "0")
      return `${m}.${day} ${h}:${min}`
    }

    async function fetchBugStats() {
      try {
        const all = await sql_query(`SELECT * FROM bug_report ORDER BY created_at DESC`)
        const list = all || []
        bugStats.value = {
          total: list.length,
          pending: list.filter(r => r.status === "pending").length,
          reviewing: list.filter(r => r.status === "reviewing").length,
          resolved: list.filter(r => r.status === "resolved").length,
          closed: list.filter(r => r.status === "closed").length,
        }
        recentBugs.value = list.slice(0, 5)
      } catch (e) {
        console.error(e)
      }
    }

    onMounted(() => {
      fetchBugStats()
    })

    return {
      member_info,
      bugStats,
      recentBugs,
      formatDate,
    };
  }
};

</script>


<style scoped>
#circleContainer {
  width:100%;
  height:100%;
  margin:0 auto;
}
.admin-main {
  width:100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: var(--color-background);
}

.admin-main > .header { 
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}

.content {
  width:100%;
  height:100%;
  flex:1;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:16px;
}

.header {
  width:100%;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

.header > h2 {
  font-size: 24px;
  color: var(--color-text-primary);
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding:0;
  margin:0;
  gap:12px;
}

.header > h2 > b {
  font-size:36px;
}

.item {
  width:100%;
  height:fit-content;
  display:flex;
}

.item > ul.row-list {
  width:100%;
  height:fit-content;
  list-style: none;
  padding:0;
  margin:0;
  display:flex;
  flex-direction: row;
  gap:12px;
}

.item > ul.row-list > li {
  width:100%;
  height: 120px;
  flex:1;
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  color: var(--color-text-primary);
  background-color: var(--color-surface-reverse);
  border:1px solid var(--color-text-secondary);
  border-radius: 12px;
  margin:0;
}

.item > ul.row-list > li > .top {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding:12px;
  box-sizing: border-box;
}

.item > ul.row-list > li > .top > .left {
  flex:1;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:6px;
}

.item > ul.row-list > li > .top > .left > h2 {
  font-size: 20px;
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

.item > ul.row-list > li > .top > .left > span {
  font-size: 14px;
  color: var(--color-text-primary);
}

.item > ul.row-list > li > .top > .right {
  height:50px;
  width:auto;
  aspect-ratio: 1/1;
  display:flex;
  justify-content: center;
  align-items: center;
}

.item > ul.row-list > li > .top > .right > h2 {
  font-size: 24px;
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

.item > ul.row-list > li > .bottom {
  width:100%;
  height:36px;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  border-top:1px solid var(--color-text-primary);
  padding:12px;
  box-sizing: border-box;
}

.item > ul.row-list > li > .bottom > span {
  font-size: 14px;
  color: var(--color-text-primary);
}

.whole {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:12px;
  padding:16px;
  box-sizing: border-box;
  background-color: var(--color-surface-reverse);
  border-radius: 12px;
}

.section-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-header > h3 {
  font-size: 16px;
  color: var(--color-text-primary);
  margin: 0;
  font-weight: 600;
}

.pending-count {
  color: #ffaa00 !important;
}

.recent-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recent-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid var(--color-background-light);
  gap: 12px;
}

.recent-left {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot.pending { background: #ffaa00; }
.status-dot.reviewing { background: #3c82f6; }
.status-dot.resolved { background: #22c55e; }
.status-dot.closed { background: #9ca3af; }

.recent-info {
  min-width: 0;
  flex: 1;
}

.recent-info > h4 {
  font-size: 14px;
  color: var(--color-text-primary);
  margin: 0;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recent-info > p {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recent-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.recent-right > .reporter {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.recent-right > .date {
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.7;
}

.no-data {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-data > p {
  font-size: 14px;
  color: var(--color-text-secondary);
}
</style>